import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import classNames from 'classnames';

const noResourceRequestCreatedInfo = (
  <FormattedMessage id="rescheduleProject.noResourceRequests" />
);

const useStyles = makeStyles(theme => ({
  message: {
    padding: 0
  },
  messageFontSize: {
    fontSize: theme.spacing(1.5)
  }
}));

export const ResourceRequestsInfo = ({
  resourceRequestsStatusCountSummary,
  isPsaRmpTaskAllocation1Enabled
}) => {
  const classes = useStyles();

  const { total, completed, proposed } = resourceRequestsStatusCountSummary;
  const showResourceRequestInfo = total === 0 || completed > 0 || proposed > 0;
  const acceptedResources = {
    value: completed
  };

  const alertClasses = useMemo(
    () => ({
      message: classNames(classes.message, {
        [classes.messageFontSize]:
          isPsaRmpTaskAllocation1Enabled && proposed > 0
      })
    }),
    [
      classes.message,
      classes.messageFontSize,
      isPsaRmpTaskAllocation1Enabled,
      proposed
    ]
  );

  const proposedResources = {
    value: proposed
  };

  const nonCompletedResourceRequestsCount = total - completed;

  const nonCompletedResourceRequestValue = {
    count: nonCompletedResourceRequestsCount
  };

  const resourcesInfo = useMemo(
    () => (
      <>
        {!isPsaRmpTaskAllocation1Enabled && completed > 0 ? (
          <FormattedMessage
            id="rescheduleProject.acceptedResourcesCount"
            values={acceptedResources}
          />
        ) : null}
        {isPsaRmpTaskAllocation1Enabled &&
        nonCompletedResourceRequestsCount > 0 ? (
          <FormattedMessage
            id="rescheduleProject.resourceRequestsCount"
            values={nonCompletedResourceRequestValue}
          />
        ) : null}
        {proposed > 0 ? (
          <FormattedMessage
            id="rescheduleProject.proposedResourcesCount"
            values={proposedResources}
          />
        ) : null}
      </>
    ),
    [
      isPsaRmpTaskAllocation1Enabled,
      completed,
      acceptedResources,
      nonCompletedResourceRequestsCount,
      nonCompletedResourceRequestValue,
      proposed,
      proposedResources
    ]
  );

  if (!isPsaRmpTaskAllocation1Enabled && !showResourceRequestInfo) return null;

  const showInfo = isPsaRmpTaskAllocation1Enabled
    ? nonCompletedResourceRequestsCount === 0
    : total === 0;

  return (
    <Alert icon={false} severity="info" size="small" classes={alertClasses}>
      {showInfo ? noResourceRequestCreatedInfo : resourcesInfo}
    </Alert>
  );
};

ResourceRequestsInfo.propTypes = {
  resourceRequestsStatusCountSummary: PropTypes.object,
  isPsaRmpTaskAllocation1Enabled: PropTypes.bool
};

export default ResourceRequestsInfo;
